// TODO: rewrite the classes and selectors in other components here.
export const overflowHiddenClass = 'xvx-overflow-hidden';
export const modalClass = 'xvx-modal';
export const openModalClass = `${modalClass}--open`;
export const closeModalSelector = `.${modalClass}__close`;
export const modalAjaxLinkSelector = `a.${modalClass}__ajax`;
export const modalOpenerSelector = '.js-xvx-modal-opener';
export const modalHeaderClass = `${modalClass}__header`;
export const modalHeaderSelector = `.${modalClass}__header`;
export const modalElevatedHeaderClass = `${modalHeaderClass}--elevated`;
export const modalBodySelector = `.${modalClass}__body`;

export const getHeaderClasses = (prefix) => ({
  overflowHiddenClass: `${prefix}overflow-hidden`,
  overflowHiddenFixedClass: `${prefix}overflow-hidden-fixed`,
  menuActionClass: `${prefix}menu-action`,
  headerMenuBorderClass: `${prefix}header-menu__border`,
  headerMenuBorderOpenClass: `${prefix}header-menu__border--open`,
  menuIconClass: `${prefix}menu-icon`,
  menuIconActiveClass: `${prefix}menu-icon--active`,
  menuContainerClass: `${prefix}menu-container`,
  menuContainerExpandedClass: `${prefix}menu-container--expanded`,
  menuSubClass: `${prefix}menu__sub`,
  menuItemAnchorActiveClass: 'active',
  menuItemLiClass: `${prefix}menu__item`,
  menuUlClass: `${prefix}menu`,
  menuItemAnchorClass: `${prefix}menu__content`,
  menuAction: `${prefix}menu-action`,
  headerClass: `${prefix}header`,
  headerSelector: `.${prefix}header`,
});

export const navigationClass = 'xvx-navigation';
export const navigationSelector = `.${navigationClass}`;

export const disableTabClass = 'xvx-js-disable-tab';
export const disableTabSelector = `.${disableTabClass}`;

export const hideElementEnhanceClass = 'xvx-hide-enhance';
export const showElementEnhanceClass = 'xvx-show-enhance';
export const hidePPVXElementEnhanceClass = 'xppvx_hide-enhance';
export const showPPVXElementEnhanceClass = 'xppvx_show-enhance';

export const getStickyClasses = (prefix) => ({
  stickyElementClass: `${prefix}sticky-banner`,
  stickyElementTopClass: `${prefix}sticky-banner-top`,
  stickyElementContrastClass: `${prefix}sticky-banner--contrast`,
  stickyElementTopContrastClass: `${prefix}sticky-banner-top--contrast`,
  stickyElementSelector: `.${prefix}sticky-banner`,
  stickyElementsSelector: `.${prefix}sticky-banner, .${prefix}sticky-banner-top`,
  stickyCloseElementClass: `js-${prefix}sticky-banner-close`,
  stickyCloseElementSelector: `.js-${prefix}sticky-banner-close`,
});

export const listMessageSelector = '.xvx-list--message';
export const listFieldFooterMessageSelector = '.xvx-item-footer-message';

export const formClass = 'xvx-form';
export const formSelector = `.${formClass}`;
export const formRowClass = `${formClass}__row`;
export const formRowSelector = `.${formRowClass}`;
export const formRowItemConfigClass = 'xvx-form-row-item-config';
export const formRowItemConfigSelector = `.${formRowItemConfigClass}`;
export const itemFooterMessageClass = 'xvx-item-footer-message';
export const itemFooterMessageSelector = `.${itemFooterMessageClass}`;
export const visibilityManagerClass = 'xvx-visibility-manager';
export const delayedAppearanceVisibilityManagerClass = 'xvx-visibility-manager--delayed-appearance';
export const visibilityManagerSelector = `.${visibilityManagerClass}`;

export const fontCopyClass = 'xvx-font-copy';
export const fontCopySelector = `.${fontCopyClass}`;
export const fontCopyErrorClass = 'xvx-font-copy-error';
export const fontCopyErrorSelector = `.${fontCopyErrorClass}`;
export const iconfontCopyErrorClass = `${fontCopyErrorClass}--icon`;

export const tooltipClass = 'xvx-tooltip';
export const tooltipSelector = `.${tooltipClass}`;
export const tooltipTriggerClass = `${tooltipClass}__trigger`;
export const tooltipTriggerSelector = `.${tooltipTriggerClass}`;
export const tooltipContentClass = `${tooltipClass}__content`;
export const tooltipContentSelector = `.${tooltipContentClass}`;
export const tooltipCloseClass = `${tooltipClass}__close`;
export const tooltipCloseSelector = `.${tooltipCloseClass}`;
export const tooltipPointerClass = `${tooltipClass}__pointer`;
export const tooltipPointerSelector = `.${tooltipPointerClass}`;
export const tooltipBodyClass = `${tooltipClass}__body`;
export const tooltipBodySelector = `.${tooltipBodyClass}`;
export const fileUploaderClass = 'xvx-file-uploader';
export const fileUploaderSelector = `.${fileUploaderClass}`;
export const fileUploaderInputClass = `${fileUploaderClass}__input`;
export const fileUploaderInputSelector = `.${fileUploaderInputClass}`;
export const fileUploaderNotEnhacedClass = `js-${fileUploaderClass}-not-enhanced`;
export const fileUploaderNotEnhacedSelector = `.${fileUploaderNotEnhacedClass}`;

export const getLoaderSpinnerClasses = (prefix) => ({
  loaderSpinnerBaseClass: `${prefix}loader-spinner`,
  loaderSpinnerLayerClass: `${prefix}loader-spinner-layer`,
  loaderSpinnerLayerSelector: `.${prefix}loader-spinner-layer`,
  loaderSpinnerJsFixedClass: `js-${prefix}loader-spinner-fixed`,
  loaderSpinnerJsFullLayerClass: `js-${prefix}loader-spinner-full-layer`,
  loaderSpinnerJsFullLayerSelector: `.js-${prefix}loader-spinner-full-layer`,
  loaderSpinnerJsPartialLayerClass: `js-${prefix}loader-spinner-partial-layer`,
  loaderSpinnerSecondaryTextClass: `${prefix}loader-spinner__secondary-text`,
  loaderSpinnerSecondaryTextSelector: `.${prefix}loader-spinner__secondary-text`,
});

export const xoomFooterClass = 'xoom-footer';
export const xoomFooterSelector = `.${xoomFooterClass}`;

export const focusableSelector = [
  'a[href]',
  'input:not([disabled])',
  'select:not([disabled])',
  'textarea:not([disabled])',
  'button:not([disabled])',
  '[tabindex]:not([tabindex="-1"])',
].join(',');

export const layoutClass = 'xppvx_layout';
export const layoutSelector = `.${layoutClass}`;
